export default [
	{
		sentiment: 0.1403
	}
];
